// Page « Nouveautés » (23/10/2026) : évolutions de l'application destinées aux
// utilisateurs (audience « client » de src/config/changelog.json, servies par
// /api/help/changelog), les plus récentes en premier, filtre par catégorie.
// Ouvrir la page marque les nouveautés comme vues (indicateur du menu profil).
import { useState, useEffect } from "react";
import api from "../services/api";

// Seules les nouveautés et améliorations sont publiées (règle éditoriale du journal)
const CATS = [
  { key: "", label: "Toutes" },
  { key: "nouveaute", label: "Nouveautés" },
  { key: "amelioration", label: "Améliorations" },
];
const CAT_LABEL = { nouveaute: "Nouveauté", amelioration: "Amélioration" };
const CAT_COLOR = { nouveaute: "#16a34a", amelioration: "#2563eb" };
const frDay = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export default function Nouveautes() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [cat, setCat] = useState("");

  useEffect(() => {
    api.help.changelog()
      .then(d => {
        setData(d);
        // Vu : l'indicateur du menu profil disparaît (les badges « Nouveau » restent pour cette visite)
        api.help.changelogSeen().then(() => window.dispatchEvent(new Event("execpro360:changelog-seen"))).catch(() => {});
      })
      .catch(e => setError(e.message));
  }, []);

  const entries = (data?.entries || []).filter(e => !cat || e.category === cat);
  const days = [...new Set(entries.map(e => e.date))];

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Nouveautés</h2>
      </div>
      <p style={{ fontSize: 13, color: "var(--text-muted)", marginTop: -6, marginBottom: 14 }}>
        Les évolutions d'ExecPro360, des plus récentes aux plus anciennes (heures de Paris).
      </p>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
        {CATS.map(c => (
          <button key={c.key} className={`btn sm${cat === c.key ? " primary" : ""}`} onClick={() => setCat(c.key)}>{c.label}</button>
        ))}
      </div>
      {error && <div className="alert danger">{error}</div>}
      {!data && !error && <div style={{ color: "var(--text-muted)" }}>Chargement…</div>}
      {data && !entries.length && <div className="alert info">Aucune évolution dans cette catégorie.</div>}
      {days.map(day => (
        <div key={day} style={{ marginBottom: 18 }}>
          <div style={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4, color: "var(--text-muted)", marginBottom: 8 }}>{frDay(day)}</div>
          {entries.filter(e => e.date === day).map(e => (
            <div key={e.id} className="card" style={{ marginBottom: 8, padding: "12px 16px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: CAT_COLOR[e.category] }}>{CAT_LABEL[e.category]}</span>
                {e.time && <span style={{ fontSize: 11, color: "var(--text-muted)" }}>{e.time}</span>}
                {e.unseen && <span style={{ fontSize: 10.5, fontWeight: 700, padding: "1px 7px", borderRadius: 99, background: "#fef3c7", color: "#92400e" }}>Nouveau</span>}
              </div>
              <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>{e.title}</div>
              <div style={{ fontSize: 13, lineHeight: 1.5 }}>{e.description}</div>
              {e.impact && <div style={{ fontSize: 12.5, color: "var(--text-muted)", marginTop: 6 }}><strong>Ce que ça change pour vous :</strong> {e.impact}</div>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
